module.exports = "<div id=\"SFA\" ng-show=\"vm.showSfa\" ng-bind-html=\"vm.sfaHtml\"></div>\n";